import React from 'react';
import { useActivities } from '../context/ActivitiesContext';
import RoomCard from '../components/RoomCard';
import { RoomCardSkeleton } from '../components/Skeleton';

const Live = () => {
  const { rooms, loading } = useActivities();
  
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 md:py-12">
      <div className="mb-12 text-center md:text-left">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight mb-4">Live Interactions</h1>
        <p className="text-gray-500 font-medium text-lg md:text-xl max-w-2xl">Jump into active rooms and contribute to the conversation in realtime.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {loading ? (
          Array(6).fill(0).map((_, i) => <RoomCardSkeleton key={i} />)
        ) : Array.isArray(rooms) && rooms.length > 0 ? (
          rooms.map((room) => (
            <RoomCard
              key={room.id}
              room={room}
              featured={room.status?.toLowerCase() === 'live'}
            />
          ))
        ) : (
          <div className="col-span-full py-20 text-center bg-gray-50 rounded-[2rem] border border-dashed border-gray-200">
            <h3 className="text-xl font-bold text-gray-900 mb-2">No active sessions</h3>
            <p className="text-gray-500">There are no live or upcoming sessions at the moment.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Live;
